// @flow
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import isEmpty from 'ramda/es/isEmpty';
import find from 'ramda/es/find';
import reduce from 'ramda/es/reduce';
import dropLast from 'ramda/es/dropLast';

import Breadcrumb, { BreadcrumbItem } from 'app/common/ui/Breadcrumb';
// $FlowFixMe
import { breadcrumbFetch } from 'app/common/actions/shop/catalog/breadcrumb';
import { DotsLoader } from 'app/common/components/Loader';

import styles from './LoadingBreadcrumb.module.scss';;


const defRoot = '/';

type Props = {
  splat?: string,
  lastTitle?: string,
  baseUrl?: string,
  removeLast?: boolean,
}

const LocalBreadcrumb = ({
  splat,
  lastTitle,
  baseUrl = defRoot,
  removeLast,
}: Props) => {
  const dispatch = useDispatch();

  // путь для хлебных крошек в массиве
  const slugs = useMemo(() => {
    const arr = splat ? splat.split('/') : [];
    return removeLast ? dropLast(1, arr) : arr;
  }, [splat, removeLast]);

  // ссылки
  const links = useMemo(() => (
    reduce((acc, value) => {
      acc.x = `${acc.x}/${value}`;
      acc[value] = `${baseUrl}${acc.x}`;
      return acc;
    }, { x: '' }, slugs)
  ), [slugs, baseUrl]);

  const titles = useSelector(state => state.shop.catalog.breadcrumb.data, shallowEqual);
  const loading = useSelector(state => state.shop.catalog.breadcrumb.loading, shallowEqual);

  useEffect(() => {
    if (isEmpty(slugs)) return;
    if (find(slug => !titles[slug], slugs)) {
      dispatch(breadcrumbFetch(slugs));
    }
  }, [slugs, titles, dispatch]);


  if (loading) {
    return (<DotsLoader className={styles.loading} />);
  }

  return (
    <Breadcrumb>
      <BreadcrumbItem href={baseUrl} key="catalog">{'Каталог'}</BreadcrumbItem>
      {slugs.map(slug => (
        <BreadcrumbItem
          href={links[slug]}
          key={slug}
        >
          {titles[slug] || slug}
        </BreadcrumbItem>
      ))}
      {lastTitle
        && <BreadcrumbItem key="_last_">{lastTitle}</BreadcrumbItem>}
    </Breadcrumb>
  );
};

export default LocalBreadcrumb;
